/**
 * 常用工具类
 */
import React from 'react';
import { MobXProviderContext } from 'mobx-react';
import { isEmpty } from 'lodash';
import dayjs from 'dayjs';
import { Toast, Modal, Flex } from 'antd-mobile';
import Cookies from 'js-cookie';
import Config from 'config/Config';
import Stores from 'config/Stores';
import * as Pinyin from 'jian-pinyin';
import copy from 'copy-to-clipboard';

import {
  openCardTextLess,
  oldOpenCardText,
  openCardText,
  routeAuthCodeMap,
  learningMenuMap,
  sendMsgParams,
  sendMsgParamsUat
} from 'utils/constants';

import { isHasRouteAuth } from 'utils/authUtil';
import { processImg } from './processImg';
import { formatMoney as formatMoneyNew } from 'middlePlatform/utils/formatMoney';

const keyArr = [
  Config.localStorageKeys.loginGoback,
  Config.localStorageKeys.registerRoute,
  'wechat_share_back'
];
class util {
  /**
   * 十六进制颜色 转 标准RGB
   * 返回的 h, s, 和 l 在 [0, 1] 之间
   *
   * @param   string  hex     带“#”字符的小写字符串
   * @return  Array   [h, s, l]  HSL各值数组
   *
   * #aad9f0 => [170, 217, 240]
   *
   */
  static doHexToRGB(hex) {
    const reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

    // 正则判断
    if (!hex || !reg.test(hex)) {
      console.log(`ColorUtil - hex = ${hex} reg fail`);
      return [];
    }
    // console.log('ColorUtil - hex = ' + hex + ' reg succ');

    const r = parseInt(`0x${hex.slice(1, 3)}`);
    const g = parseInt(`0x${hex.slice(3, 5)}`);
    const b = parseInt(`0x${hex.slice(5, 7)}`);

    const rgbArr = [r, g, b];
    // console.log('ColorUtil - doHexToRGB = ' + JSON.stringify(rgbArr));

    return rgbArr;
  }

  // 打印mobx监视的对象(mobx只能看到get set的函数，无法看到完整的数据结构)
  static log(log) {
    return JSON.parse(JSON.stringify(log));
  }

  static calculateTextWidth(text, font) {
    const element = document.createElement('canvas');
    const context = element.getContext('2d');
    context.font = font;
    return context.measureText(text).width;
  }

  // 判断是否iphoneX
  static isIphoneX() {
    if (/iphone/gi.test(navigator.userAgent)) {
      // (window.innerWidth == 375*3) && (window.innerHeight == 724*3)
      return window.devicePixelRatio === 3 && screen.height == 812 && screen.width == 375;
    }
    return false;
  }

  // 判断是安卓还是ios
  static androidOrios() {
    const u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
      return 'Android';
    }
    if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      return 'IOS';
    }
  }

  // 给local缓存值
  static setLocalCache(c_name, value) {
    if (keyArr.includes(c_name)) {
      sessionStorage.setItem(c_name, JSON.stringify(value));
    } else {
      localStorage.setItem(c_name, JSON.stringify(value));
    }

    // Cookies.set(c_name, JSON.stringify(value));
  }

  // 取回local
  static getLocalCache(c_name) {
    let tem = '';
    if (keyArr.includes(c_name)) {
      tem = sessionStorage.getItem(c_name) || localStorage.getItem(c_name);
    } else {
      tem = localStorage.getItem(c_name);
    }
    if (tem) {
      try {
        return JSON.parse(tem);
      } catch (error) {
        return '';
      }
    }
    return tem;
  }

  static clearOPenCardLocalData() {
    this.setLocalCache(Config.localStorageKeys.member_cardTypeData, '');
    this.setLocalCache(Config.localStorageKeys.member_agentApplyCardMsg, '');
    this.setLocalCache(Config.localStorageKeys.member_storeAgentApplyCardMsg, '');
    this.setLocalCache(Config.localStorageKeys.member_cardTypeData, '');
    this.setLocalCache(Config.localStorageKeys.shop_cardTypeData, '');
    this.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, '');
    this.setLocalCache(Config.localStorageKeys.menber_helpUserId, '');

    this.setLocalCache(Config.localStorageKeys.virtual_applyCardOrderParams, '');
    this.setLocalCache(Config.localStorageKeys.virtual_applyCardMsg, '');
    this.setLocalCache('isVirtualPoint', '');
    this.setLocalCache('virtualPointId', '');
    this.setLocalCache('virtualUserId', '');
    this.setLocalCache('virtualNeedOrder', '');
    this.setLocalCache('virtualFreeFreight', '');
    this.setLocalCache('targetVirtualPlanId', '');
  }

  /**
   * 证件号、手机号脱敏展示，规则为只展示前3位及后4位，中间数字用*号展示
   */
  static encryptStr(str) {
    if (!str || str.length < 7) {
      return str || '';
    }
    return str.substring(0, 3) + '*'.repeat(str.length - 7) + str.substring(str.length - 4);
  }

  /**
   * 银行卡号脱敏显示，中间8位用*号展示
   */
  static encrypBankCard(str) {
    if (!str || str.length <= 10) {
      return str || '';
    }
    const strLength = (str.length || 19) - 10;
    let index = Math.ceil((str.length - 8) / 2);
    const strEndLength = str.length - 4;
    return str.substring(0, 6) + '*'.repeat(strLength) + str.substring(strEndLength, str.length);
  }

  /**
   * 金钱格式化
   * @param {*} value 金额（支持带货币符号的字符串、纯数字、空值等）
   * @param {*} showPrefix 是否要显示单位
   * @param {*} precision 小数位数，默认2
   * @param {*} needPoint 是否要做千分位处理，默认true
   * @param {*} showMinus 是否显示负号，默认false
   */
  static formatMoney(params) {
    return formatMoneyNew(params);
  }

  /**
   * 反向金钱格式化（目标币种金额转回人民币，与formatMoney反向换算）
   * @param {*} value 目标币种金额（支持带货币符号的字符串、纯数字、空值等）
   * @param {*} showPrefix 是否要显示人民币单位（默认￥）
   * @param {*} precision 小数位数，默认2
   * @param {*} needPoint 是否要做千分位处理，默认true
   * @param {*} showMinus 是否显示负号，默认false
   */
  static reverseFormatMoney(params) {
    if (typeof params !== 'object') {
      params = {
        value: params
      };
    }
    let {
      value,
      showPrefix = true,
      precision = 2,
      needPoint = true,
      showMinus = false,
      ignoreExchange = false, // 是否忽略汇率转换（忽略则直接返回原金额格式化结果）
      exchangeRate, // 自定义汇率（目标币种→人民币的汇率，优先级高于 appMod.currentExchangeRate）
      currencySymbol = '￥' // 反向换算后默认显示人民币符号
    } = params || {};

    // ========== 1. 提取纯数字（与原方法完全一致的逻辑） ==========
    // 处理空值/undefined
    if (value === null || value === undefined || value === '') {
      value = 0;
    }
    // 转为字符串 → 过滤空格 → 过滤非数字/小数点/负号
    const valueStr = String(value).trim().replace(/\s+/g, '');
    const pureNumStr = valueStr.replace(/[^0-9.-]/g, '');
    // 严格校验有效数字
    let pureValue = 0;
    if (pureNumStr) {
      const num = Number(pureNumStr);
      if (!isNaN(num)) {
        pureValue = num;
      }
    }

    // ========== 2. 确定反向汇率（核心：原汇率取倒数） ==========
    let finalExchangeRate = 1;
    if (!ignoreExchange) {
      // 获取原汇率（目标币种/人民币），反向汇率 = 1 / 原汇率
      let originExchangeRate = 1;
      if (exchangeRate !== undefined) {
        originExchangeRate = exchangeRate;
      } else {
        try {
          const appMod = Stores.AppMod;
          if (appMod) {
            originExchangeRate = appMod.currentExchangeRate || 1;
          }
        } catch (e) {
          console.warn('获取原汇率失败，使用默认汇率1', e);
        }
      }
      // 反向汇率：人民币 = 目标币种金额 / 原汇率（避免除以0）
      finalExchangeRate = originExchangeRate !== 0 ? 1 / originExchangeRate : 1;
    }
    console.log('反向汇率 finalExchangeRate', finalExchangeRate);

    // ========== 3. 反向换算金额（目标币种 → 人民币） ==========
    const convertedValue = pureValue * finalExchangeRate;

    // ========== 4. 格式化处理（与原方法完全一致的逻辑） ==========
    const displayPrefix = showPrefix ? currencySymbol : '';
    const point = needPoint ? ',' : '';

    // 兜底处理
    let valueStrFinal = String(convertedValue).replace(/(^\s*)|(\s*$)/g, '');
    if (isNaN(valueStrFinal) || !valueStrFinal) {
      return (showMinus ? '-' : '') + displayPrefix + parseFloat(0).toFixed(precision);
    }
    valueStrFinal = parseFloat(valueStrFinal).toFixed(precision);

    // 转换为字符串，处理千分位和负号
    valueStrFinal += '';
    let isDecimals = false;
    if (valueStrFinal) {
      const nums = valueStrFinal.split('.');
      let integer = nums[0];
      const decimals = nums[1];
      // 处理负数
      if (integer.indexOf('-') > -1) {
        integer = integer.slice(integer.indexOf('-') + 1);
        isDecimals = true;
      }
      // 千分位处理
      const num = integer.slice(integer.length % 3);
      const numBegin = integer.slice(0, integer.length % 3);
      valueStrFinal =
        numBegin +
        (numBegin && num ? point : '') +
        (num ? num.match(/\d{3}/g).join(point) : '') +
        (decimals ? `.${decimals}` : '');
    }

    // 返回最终格式化结果
    return convertedValue;
  }

  /**
   * 字符串切割替换
   * @param {string} val 初始值
   * @param {number} start 开始位置
   * @param {number} end 结束位置
   * @param {string} replaceString 替换字符
   */
  static formatString(val, start, end, replaceString) {
    const ruten = val.substring(start, end); // 提取字符串下标之间的字符。
    return val.replace(ruten, replaceString);
  }

  // checkInput 检查姓名，手机，验证码的格式
  static checkInput(value, type) {
    // 国际版不走校验逻辑
    if (Stores.AppMod.isInternationalized && value) return true;
    const maps = {
      password:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]).{8,16}$/,
      mobile: /^[1*][3456789*][\d|*]{5}(\d){4}$/,
      // mobile: /^[1]([3-9])[0-9]{9}$/,
      verifyCode: /^\d{6}$/g,
      realName: /^[a-zA-Z\u4e00-\u9fa5]{2,10}$/gi,
      tel: /^(0\d{2}-\d{8}(-\d{1,4})?)|(0\d{3}-\d{7,8}(-\d{1,4})?)$/,
      email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      number: /^\d*$/g,
      money: /^(0|[1-9][0-9]*)$/,
      address: /^[\da-zA-Z\u4e00-\u9fa5]{3,60}$/gi,
      limitMoney: /^((0|[1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
      chinese: /^[\u4e00-\u9fa5]+$/,
      alp: /^[a-zA-Z]+$/,
      bank: /^(\d{16}|\d{19})$/,
      // 英文数字
      account: /^[a-zA-Z\d]+$/,
      // 中英文
      userName: /^[a-zA-Z\u4e00-\u9fa5]+$/,
      // 中英文数字
      nonSymbol: /^[a-zA-Z\u4e00-\u9fa5\d]+$/,
      // 边输入边校验的“中英文数字”（缺陷：可输入`和空格）
      nonSymbolEntering: /^[a-zA-Z\u4e00-\u9fa5\d`\s]+$/,
      // 数字、中英文、常规字符，可用于地址等
      commonChars: /^[\u4e00-\u9fa5a-zA-Z0-9?'()（）*+,-./;=[\]` ]+$/,
      // 身份证号(仅校验非脱敏场景) 已知的场景有代客开卡 代客开店
      id: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
      // 身份证号(脱敏校验) 前2后2明文 中间*
      newId:
        /^[1-9]\d[\d|*]{4}(18|19|20|[*]{2})[\d|*]{2}((0[1-9])|(1[0-2])|[*]{2})(([0-2][1-9])|10|20|30|31|[*]{2})[\d|*]{2}\d[0-9Xx]$/
    };
    return maps[type].test(value);
  }

  /**
   * 三生项目的名字输入规则
   * 长度：1 <= length <= 50
   * 非空
   * 前后不能有空格
   * 其余特殊字符都不限制
   * showMsg: 是否弹出吐司
   */
  static getStrictName(name = '', showMsg = true) {
    name = name.trim();
    if (!name) {
      showMsg && Toast.info('姓名不能为空');
      return '';
    }

    if (name.charAt(0) === ' ') {
      showMsg && Toast.info('姓名第一个字不能为空格');
      return '';
    }

    if (!!name && name.length < 2) {
      showMsg && Toast.info('姓名长度不能小于2');
      return '';
    }

    if (!!name && name.length > 50) {
      showMsg && Toast.info('姓名长度不能大于50');
      return '';
    }

    return name;
  }

  // trim
  static trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
  }

  // stringfy
  static qs(obj) {
    const arr = [];
    // eslint-disable-next-line guard-for-in
    for (const i in obj) {
      arr.push(`${i}=${obj[i]}`);
    }
    return arr.join('&');
  }

  // 日期过滤
  static dateFormat(val, isneed = true) {
    const date = new Date(this.exchangeTime(val));
    let yymm = `${date.getFullYear()}年${date.getMonth() + 1}月`;
    return isneed ? `${yymm}${date.getDate()}日` : yymm;
  }

  // 年月过滤
  static monthYearFormat(val) {
    if (val) {
      const date = new Date(this.exchangeTime(val));
      return `${date.getFullYear()}年${date.getMonth() + 1}月`;
    }
  }

  // 从url取值
  static getQueryString(name = '') {
    const hash = window.location.hash || '';
    // 参数值里可能包含 ?，这里只按第一个 ? 截取完整 query。
    const queryIndex = hash.indexOf('?');
    const after = queryIndex > -1 ? hash.slice(queryIndex + 1) : '';
    if (after && name) {
      const reg = new RegExp(`(^|&)${name.trim()}=([^&]*)(&|$)`);
      const r = after.trim().match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    }
  }

  // 从参数url取值
  static getParamsQueryString(url, name = '') {
    // 参数值里可能包含 ?，这里只按第一个 ? 截取完整 query。
    const queryIndex = url.indexOf('?');
    const after = queryIndex > -1 ? url.slice(queryIndex + 1) : '';
    if (after && name) {
      const reg = new RegExp(`(^|&)${name.trim()}=([^&]*)(&|$)`);
      const r = after.trim().match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    }
  }

  // 从url取值
  static getQueryStringBefore() {
    const before = window.location.hash.split('?')[0] || '';
    if (before) {
      const newArray = before.split('/');
      if (Array.isArray(newArray) && newArray.length > 0) {
        return newArray[newArray.length - 1];
      }
      return null;
    }
  }

  // 时间转换
  static formatDate(str, type = 1) {
    const [y, m, d, h, min, s] = str.replace(/[-|:]/g, ' ').split(' ');
    let ns = '';
    switch (type) {
      case 1:
        ns = `${y}.${m}.${d}`;
        break;
      case 2:
        ns = `${y}.${m}.${d} ${h}:${min}:${s}`;
        break;
      case 3:
        ns = `${y}.${m}.${d} ${h}:${min}`;
        break;
    }
    return ns;
  }

  /**
   *  通用日期格式化
   * @param {*} timestamp
   * @param {*} formater
   */
  static formatDateTime(timestamp, formater) {
    let date = new Date();
    if (typeof timestamp === 'number') {
      date.setTime(parseInt(timestamp));
    } else if (typeof timestamp === 'string') {
      if (timestamp.indexOf('-') >= 0) {
        let regEx = new RegExp('\\-', 'gi');
        let validDateStr = timestamp.replace(regEx, '/');
        let milliseconds = Date.parse(validDateStr);
        date.setTime(milliseconds);
      }
    } else if (timestamp instanceof Date) {
      date = timestamp;
    }

    formater = formater != null ? formater : 'yyyy-MM-dd hh:mm';
    Date.prototype.Format = function (fmt) {
      // author: meizz
      let o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'h+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        S: this.getMilliseconds() // 毫秒
      };

      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, `${this.getFullYear()}`.substr(4 - RegExp.$1.length));
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
          );
      }
      return fmt;
    };
    return date.Format(formater);
  }

  // 获取时间戳
  static getTimestamp(str) {
    const dates = str.replace(/[-]/g, '/');
    const ts = new Date(dates).getTime();
    return ts;
  }

  static replaceHuaweiCloud(url) {
    if (!url) return url;
    const returnUrl = url
      .replace(/image-test.yofoto.cn/g, 'yofoto-test.obs.cn-east-2.myhuaweicloud.com')
      .replace(/image.yofogo.com/g, 'bucket-prod.obs.cn-east-2.myhuaweicloud.com')
      .replace(/image-uat.yofoto.cn/g, 'bucket-uat.obs.cn-east-2.myhuaweicloud.com');
    return returnUrl;
  }

  // 获取滚动条高度
  static getScrollTop() {
    let scrollTop = 0;
    // pc
    if (document.documentElement && document.documentElement.scrollTop) {
      // eslint-disable-next-line prefer-destructuring
      scrollTop = document.documentElement.scrollTop;
    } else if (document.body) {
      // 移动
      // eslint-disable-next-line prefer-destructuring
      scrollTop = document.body.scrollTop;
    }
    return scrollTop;
  }

  // 获取滚动容器高度
  static getScrollHeight(arr) {
    let scrollHeight = document.body.clientHeight;
    for (let i = 0; i < arr.length; i++) {
      scrollHeight -= document.getElementsByClassName(arr[i])[0].clientHeight;
    }
    return scrollHeight;
  }

  /**
   * 滚动指定容器到底部
   * @param {string} selector - 容器选择器，如 '.app-wrap'
   * @param {boolean} smooth - 是否平滑滚动，默认 true
   */
  static scrollToBottom(selector, smooth = true) {
    const el = document.querySelector(selector);
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: smooth ? 'smooth' : 'auto' });
    }
  }

  // 获取经纬度
  static getCoordinate() {
    const tmp = localStorage.getItem('myPosition');
    if (tmp !== null) {
      const { longitude, latitude } = JSON.parse(tmp);
      return {
        longitude,
        latitude
      };
    }
    return {
      longitude: 113.440332,
      latitude: 23.10674
    };
  }

  static isMobile() {
    const ua = window.navigator.userAgent.toLowerCase();
    const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return !!ua.match(reg);
  }

  // 是否在微信内
  static isWeiXin() {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    const ua = window.navigator.userAgent.toLowerCase();
    // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    }
    return false;
  }

  // 是否在微信-小程序内
  static isWeChat() {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    const ua = window.navigator.userAgent.toLowerCase();
    // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (/miniProgram/i.test(ua)) {
      return true;
    }
    return false;
  }

  /**
   * 判断是否在享脉内
   * @returns {Boolean} Boolean
   */
  static isXM() {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    const ua = window.navigator.userAgent.toLowerCase();
    // 通过正则表达式匹配ua中是否含有ShareMessage字符串
    if (ua.match(/ShareMessage/i) == 'sharemessage') {
      return true;
    }
    return false;
  }
  /**
   * 判断是否在FBL小程序内
   * @returns {Boolean} Boolean
   */
  static isFblWeChat() {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    const ua = window.navigator.userAgent.toLowerCase();
    // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (/miniProgram/i.test(ua) && sessionStorage.getItem('systemCode') == 'XBL') {
      return true;
    }
    return false;
  }
  /**
   * 判断是否在有享云商APP内
   * @returns {Boolean} Boolean
   */
  static isYofoto() {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    const ua = window.navigator.userAgent.toLowerCase();
    // 通过正则表达式匹配ua中是否含有YofotoMessenger字符串
    if (ua.match(/YofotoMessenger/i) == 'yofotomessenger') {
      return true;
    }
    return false;
  }

  static checkHWLJump() {
    const location = window.location;
    const { host } = location;
    if (this.getLocalCache('member_token')) {
      // 存在TOKEN
      return;
    }
    if (['h5.xbailing.com', 'xbailingh5.uat3.yofoys.cn'].includes(host) && this.isWeChat()) {
      // hwl 小程序内跳转
      wx.miniProgram.navigateTo({
        url: `/pages/my/login/login?type=isH5&url=${encodeURIComponent(
          this.getLocalCache('loginH5Goback') || ''
        )}`
      });
      return;
    }
  }

  static previewImage(current, url = []) {
    console.log(current, url);
    if (url.length === 0) {
      url = [current];
    }
    wx.previewImage({
      // current: current, // 当前显示图片的http链接
      urls: url // 需要预览的图片http链接列表
    });
  }

  // oss改变图片尺寸
  static getImgUrl(url, width, height) {
    if (!url) {
      return '';
    }

    const dpr = window.devicePixelRatio || 1;
    // 优化处理，乘以1.5
    width = Math.round(((width * dpr) / 2) * 1.5);
    height = height ? Math.round(((height * dpr) / 2) * 1.5) : width;
    const options = {
      w: width,
      h: height
    };
    return processImg(url, options);
  }

  // 设置title信息
  static setTitle(title) {
    // 写死“有享云商”，不取route的title，是为了兼容微信、钉钉等不可动态改变title的问题
    document.title = '有享云商' || title;
    // 部分ios标题设置错误
    const $iframe = $('<iframe style="display: none; width: 0; height: 0;"></iframe>');
    $iframe.ready(function () {
      setTimeout(() => {
        $iframe.remove();
      }, 0);
    });
    $iframe.appendTo($('body'));
  }

  // get Date 获取一个日期
  static getFDate(d) {
    const y = d.getFullYear();
    const m = d.getMonth() + 1;
    const da = d.getDate();

    return `${y < 10 ? `0${y}` : y}-${m < 10 ? `0${m}` : m}-${da < 10 ? `0${da}` : da}`;
  }

  static getFTime(d) {
    const hour = d.getHours();
    const min = d.getMinutes();

    return `${hour < 10 ? `0${hour}` : hour}:${min < 10 ? `0${min}` : min}`;
  }

  // 弹窗时禁止背景滚动
  static stopBodyScroll(isFixed, back) {
    const bodyEl = document.body;
    let top = 0;
    if (isFixed) {
      top = window.scrollY;

      bodyEl.style.position = 'fixed';
      bodyEl.style.top = `${-top}px`;
    } else {
      top = Math.abs(parseInt(bodyEl.style.top));
      bodyEl.style.position = '';
      bodyEl.style.top = '';
      if (!back) {
        window.scrollTo(0, top); // 回到原先的top
      } else {
        window.scrollTo(0, 0); // 回到原先的top
      }
    }
  }

  /**
   * @name: 获取倒计时
   * @params {string/date} time 时间
   * @params {bollean} flag 是否保留天数
   * @return: {object} 天、小时，分，秒
   */
  static getCountDown(time, flag) {
    const defaultObj = {
      date: '0',
      hour: '00',
      min: '00',
      sec: '00'
    };

    if (time) {
      let Rang = 0;
      if (typeof time === 'number') {
        Rang = time * 1000;
      } else {
        const propsTimeStemp = new Date(this.exchangeTime(time)).getTime(); // props时间戳
        const nowTimeStemp = new Date().getTime(); // 当前时间戳
        Rang = propsTimeStemp - nowTimeStemp;
      }

      if (Rang <= 0) {
        return defaultObj;
      }
      const date = parseInt(Rang / (3600 * 24 * 1000)); // 天数
      let hours = parseInt((Rang % (3600 * 24 * 1000)) / (3600 * 1000)); // 小时
      let minutes = parseInt((Rang % (3600 * 1000)) / (60 * 1000)); // 分钟
      let seconds = parseInt((Rang % (60 * 1000)) / 1000); // 秒数
      const allHours = flag ? 0 : date * 24; // 将天数转换成小时
      hours = hours + allHours < 10 ? `0${hours}` : hours + allHours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;
      return {
        date,
        hour: hours,
        min: minutes,
        sec: seconds
      };
    }
    return defaultObj;
  }

  /**
   * @name: 获取最大，最小月份
   * @params {number} max 传的数据是距离现在的月份的前max月份，如1，表示上个月
   * @params {number} min  传的数据是距离现在的月份的前min月份，如6，表示6个月前
   * @params {string} curDate 设定的【现在】
   * @params {boolean} format 是否转成中文
   * @return: {object}
   */
  static getPreDate({ max, min, curDate }, format = false) {
    const date = curDate ? new Date(this.exchangeTime(curDate)) : new Date();
    const formatObj = {
      pre: format ? '年' : '-',
      next: format ? '月' : ''
    };
    const year = date.getFullYear();
    const maxMonth = date.getMonth() - max;
    const minMonth = date.getMonth() - min;
    const prevMaxData = new Date(year, maxMonth);
    const prevMinDate = new Date(year, minMonth);
    const preMinMonth = prevMaxData.getMonth() + 1;
    const preMaxMonth = prevMinDate.getMonth() + 1;
    const tmpDate = {
      maxDate: `${prevMaxData.getFullYear()}${formatObj.pre}${
        preMinMonth < 10 && !format ? `0${preMinMonth}` : preMinMonth
      }${formatObj.next}`,
      minDate: `${prevMinDate.getFullYear()}${formatObj.pre}${
        preMaxMonth < 10 && !format ? `0${preMaxMonth}` : preMaxMonth
      }${formatObj.next}`
    };
    return tmpDate;
  }

  /** 订单长度超过固定数值，做省略号展示限制
   *
   * @param {string} orderNum 订单号
   * @param {number|string} maxLen 订单最大长度值
   */
  static formatOrderNum(orderNum = '0', maxLen = 18) {
    if (orderNum.length > maxLen) {
      return `${orderNum.substring(0, maxLen - 3)}...`;
    }
    return orderNum;
  }

  static async getGeo() {
    // [Deprecation] getCurrentPosition() and watchPosition() no longer work on insecure origins. To use this feature, you should consider switching your application to a secure origin, such as HTTPS. See https://goo.gl/rStTGz for more details.
    if ('geolocation' in navigator) {
      /* 地理位置服务可用 */
      await navigator.geolocation.getCurrentPosition(function (position) {
        return {
          latitude: position.coords.latitude, // 纬度
          longitude: position.coords.longitude // 经度
        };
      });
    } else {
      /* 地理位置服务不可用 */
    }
  }

  static UNSAFE_clearData() {
    console.warn(
      '注意使用utils的clearData，由于本地存在“记住账号”、“路由次数监听”等不可清除数据，使用该方法前，请团队沟通后继续！'
    );
    sessionStorage.clear();
    localStorage.clear();
  }

  /**
   * luhn校验规则：16位银行卡号（19位通用）:
   * 1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
   * 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
   * 3.将加法和加上校验位能被 10 整除。
   * luhn算法校验银行卡
   * @param bankno
   * @returns {boolean}
   */
  static bankCardValidate(bankno) {
    const lastNum = bankno.substr(bankno.length - 1, 1); // 取出最后一位（与luhn进行比较）

    const first15Num = bankno.substr(0, bankno.length - 1); // 前15或18位
    const newArr = [];
    for (let i = first15Num.length - 1; i > -1; i--) {
      // 前15或18位倒序存进数组
      newArr.push(first15Num.substr(i, 1));
    }
    const arrJiShu = []; // 奇数位*2的积 <9
    const arrJiShu2 = []; // 奇数位*2的积 >9

    const arrOuShu = []; // 偶数位数组
    for (let j = 0; j < newArr.length; j++) {
      if ((j + 1) % 2 == 1) {
        // 奇数位
        if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
        else arrJiShu2.push(parseInt(newArr[j]) * 2);
      } // 偶数位
      else arrOuShu.push(newArr[j]);
    }

    const jishu_child1 = []; // 奇数位*2 >9 的分割之后的数组个位数
    const jishu_child2 = []; // 奇数位*2 >9 的分割之后的数组十位数
    for (let h = 0; h < arrJiShu2.length; h++) {
      jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
      jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
    }

    let sumJiShu = 0; // 奇数位*2 < 9 的数组之和
    let sumOuShu = 0; // 偶数位数组之和
    let sumJiShuChild1 = 0; // 奇数位*2 >9 的分割之后的数组个位数之和
    let sumJiShuChild2 = 0; // 奇数位*2 >9 的分割之后的数组十位数之和
    let sumTotal = 0;
    for (let m = 0; m < arrJiShu.length; m++) {
      sumJiShu += parseInt(arrJiShu[m]);
    }

    for (let n = 0; n < arrOuShu.length; n++) {
      sumOuShu += parseInt(arrOuShu[n]);
    }

    for (let p = 0; p < jishu_child1.length; p++) {
      sumJiShuChild1 += parseInt(jishu_child1[p]);
      sumJiShuChild2 += parseInt(jishu_child2[p]);
    }
    // 计算总和
    sumTotal =
      parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

    // 计算luhn值
    const k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
    const luhn = 10 - k;

    if (lastNum == luhn) {
      return true;
    }
    return false;
  }

  /**
   *  校验是否已成年。
   * @param {string} birthDay 生日 格式YYYYMMDD或者YYYY-MM-DD或者身份证号
   */
  static checkIsAdult(birthDay) {
    if (birthDay.trim().length === 18) {
      birthDay = birthDay.substring(6, 14);
    }
    const nowUnix = dayjs().unix();
    const birstDayUnix = dayjs(birthDay, ['YYYYMMDD', 'YYYY-MM-DD']).unix();
    const eighteenYearUnix = 18 * 365 * 24 * 60 * 60;
    // 当前日期时间戳-生日时间戳<18年说明未成年
    if (nowUnix - birstDayUnix < eighteenYearUnix) {
      return false;
    }
    return true;
  }

  // 转base64
  static rstr2b64(input) {
    const b64pad = '';
    const tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    let output = '';
    const len = input.length;
    for (let i = 0; i < len; i += 3) {
      const triplet =
        (input.charCodeAt(i) << 16) |
        (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) |
        (i + 2 < len ? input.charCodeAt(i + 2) : 0);
      for (let j = 0; j < 4; j++) {
        if (i * 8 + j * 6 > input.length * 8) output += b64pad;
        else output += tab.charAt((triplet >>> (6 * (3 - j))) & 0x3f);
      }
    }
    return output;
  }

  /**
   * @name: 处理通用地址展示或者保存时需要的数据
   * @params {object} address 地址数据
   * @params {string/boolean} 是否是取数据展示
   * @return:
   */
  static handleArea(address, get, refer) {
    const obj = {};
    const area = refer || ['province', 'city', 'district', 'street', 'communityName'];
    const arr = [];
    if (get && !isEmpty(address)) {
      area.forEach((item, idx) => {
        const codeKey = item === 'communityName' ? 'communityCode' : `${item}Code`;
        arr.push({
          value: address[codeKey],
          label: (address[`${item}`] && address[`${item}`]) || ''
        });
      });
      return arr;
    }
    if (!get) {
      address.area.forEach((item, idx) => {
        console.log(area);
        const nameKey = area[idx];
        const codeKey = nameKey === 'communityName' ? 'communityCode' : `${nameKey}Code`;
        obj[codeKey] = item.value;
        obj[nameKey] = item.label;
        obj.postCode = item.postCode;
      });
      // 补充未选到的级别字段为空字符串（选了"暂不选择"时数组会截断）
      for (let i = address.area.length; i < area.length; i++) {
        const nameKey = area[i];
        const codeKey = nameKey === 'communityName' ? 'communityCode' : `${nameKey}Code`;
        obj[nameKey] = '';
        obj[codeKey] = '';
      }
      // delete address.area;
      return {
        ...obj,
        ...address
      };
    }
    return [];
  }

  /**
   * 适配富文本内容的字体大小。
   * 将后端返回的富文本的字体大小单位由px转成rem
   * @param {string} innerHtml 后端返回的富文本内容
   */
  static changeRichText(innerHtml) {
    if (!innerHtml) {
      return '';
    }
    // 过滤掉base64图片
    let index = -1;
    const base64Arr = innerHtml.match(/data:image\/[^==]*==/g);
    innerHtml = innerHtml.replace(
      /data:image\/[^==]*==/g,
      `__base64Data__${+index + 1}__base64Data__`
    );
    innerHtml = innerHtml.replace(/(\d+)px/g, (match, oldPx) => `${(oldPx * 2) / 100}rem`);
    return innerHtml.replace(
      /__base64Data__(\d+)__base64Data__/g,
      (match, index) => base64Arr[index]
    );
  }

  static exchangeTime(time, init) {
    // 兼容iosDate构造函数不识别'YYYY-MM-DD'的问题
    /**
      ios 支持的格式
      yyyy/MM/dd
      MM/dd/yyyy
      MMMM dd, yyyy
      MMM dd, yyyy
    */
    // 大坑，假如这个time是只有yy-mm的，那么需要补全对应的dd
    let curTime;
    let isExitLen;
    let type;
    if (!time && time != 0) return new Date();
    if (time instanceof Date) return new Date(time);
    type = typeof time;
    if (['number', 'object'].includes(type)) return time;
    isExitLen = time.split('-').length;
    if (isExitLen == 2) {
      time += init ? `-01` : `-${new Date().getDate()}`;
    }
    curTime = time.replace(/-/g, '/');
    return curTime;
  }

  // 获取前后一百年
  static gethunTime() {
    let curTime = Date.now();
    let diff = 100 * 365 * 24 * 60 * 60 * 1000;
    return {
      min: new Date(curTime - diff),
      max: new Date(curTime + diff)
    };
  }

  // 积分pv处理
  static handleTotalPv(pv, max) {
    let maxPv = max || 18000;
    if (!pv) return pv;
    if (pv > maxPv) {
      return `${maxPv}+`;
    }
    return pv;
  }

  // 跳转客服
  static goToRobot(code, origin = 'SC') {
    window.location.href = `${window.robotPath}/cloud/robot/webui/5c0e1d28310000a7008aecc9?code=${code}&origin=${origin}`;
  }

  // 替换富文本中图片资源，添加oss缩放参数
  static replaceOssParams(matchsrc, width) {
    const reg = /(<img).*?(src.*?=.*?['"](.*?)['"]).*?(\/>|>)/g;
    const b = matchsrc.replace(reg, (text, p1, p2, p3, p4) => {
      const result = `${p1} src="${this.getImgUrl(p3, width)}" ${p4}`;
      return result;
    });
    return b;
  }

  // 计算字符串长度
  // 中文2，英文1
  static calStrLen(str) {
    let l = str.length;
    let blen = 0;
    for (let i = 0; i < l; i++) {
      if ((str.charCodeAt(i) & 0xff00) != 0) {
        blen++;
      }

      blen++;
    }
    return blen;
  }

  static checkSame(str) {
    let newStr = str[0].repeat(str.length);
    if (newStr === str) {
      return true;
    }
    return false;
  }

  // 长度< 18，不能纯中文或英文，相同数字
  static verifyOtherCard(card) {
    if (!card) {
      return '其他证件号码不能为空';
    }
    let len = this.calStrLen(card);
    if (len >= 18) {
      return '其他证件号码不能超过18位';
    }
    if (len == 15) {
      return '其他证件号码不能等于15位';
    }
    if (this.checkInput(card, 'chinese')) {
      return '其他证件号码不能是纯中文';
    }

    if (this.checkInput(card, 'alp')) {
      return '其他证件号码不能是纯英文';
    }

    if (this.checkSame(card)) {
      return '其他证件号码不能是相同数字';
    }

    return false;
  }

  // 字符串过滤空格
  static cutSpace(str) {
    // str = str.replace(' ', '');
    if (str) {
      str = str.replace(/\s/g, '');
    }
    return str;
  }

  /**
   * 传参编码，返回a=1&b=2
   */
  static encodeQuery(query) {
    let queryStr = '';
    let keys = Object.keys(query);
    keys.forEach((item, index) => {
      const itemStr = encodeURIComponent(query[item]);
      queryStr = index ? `${queryStr}&${item}=${itemStr}` : `${queryStr}${item}=${itemStr}`;
    });
    return queryStr;
  }

  /**
   * url接收参数解码，返回{}
   */
  static decodeQuery(queryStr) {
    let query = {};
    if (queryStr) {
      queryStr = decodeURIComponent(queryStr.replace('?', ''));

      let searchArr = queryStr.split('&');
      searchArr.forEach((item) => {
        let keyAndValue = item.split('=');
        query[keyAndValue[0]] = keyAndValue[1];
      });
    }

    return query;
  }

  /**
   * url接收参数解码，返回{}
   */
  static decodeQueryDecode(queryStr) {
    let query = {};
    if (queryStr) {
      queryStr = queryStr.replace('?', '');

      let searchArr = queryStr.split('&');
      searchArr.forEach((item) => {
        let keyAndValue = item.split('=');
        query[keyAndValue[0]] = decodeURIComponent(keyAndValue[1]);
      });
    }

    return query;
  }

  /**
   * 根据后台返回的媒体列表获取产品图片
   */
  static getProductImgUrl(list) {
    let imgUrl = '';
    if (list && list.length > 0) {
      // 优先取 extension==1（主图标记）且 fileType==1（图片类型）的媒体
      const primary = list.find((item) => item.extension == 1 && item.fileType == 1);
      // 次选：仅满足 fileType==1 的媒体
      const fallback = list.find((item) => item.fileType == 1);
      const target = primary || fallback;
      imgUrl = (target && (target.path1 || target.path2)) || '';
    }
    return imgUrl;
  }

  /**
   * 判断是否是json格式
   */
  static isJSON(str) {
    if (typeof str === 'string') {
      try {
        let obj = JSON.parse(str);
        if (typeof obj === 'object' && obj) {
          return true;
        }
        return false;
      } catch (e) {
        console.log(`error：${str}!!!${e}`);
        return false;
      }
    }
    console.log('It is not a string!');
  }

  static formatAppData(list) {
    const AppData = {
      order: {
        text: '我的订单',
        icon: `${CDN_BASE}/assets/imgs/shop/home/order.svg`,
        url: '/member/order'
      },
      coupon: {
        text: '我的优惠券',
        icon: `${CDN_BASE}/assets/imgs/shop/home/coupon.svg`,
        url: '/member/wallet/coupon'
      },
      collect: {
        text: '我的收藏',
        icon: `${CDN_BASE}/assets/imgs/shop/home/favorite.svg`,
        url: '/member/myCollect'
      },
      address: {
        text: '收货地址',
        icon: `${CDN_BASE}/assets/imgs/shop/home/address.svg`,
        url: '/member/addressList'
      },
      wallet: {
        text: '我的钱包',
        icon: `${CDN_BASE}/assets/imgs/shop/home/person_wallet.svg`,
        url: '/member/wallet'
      },
      speedy_shop: {
        text: '快速购物',
        icon: `${CDN_BASE}/assets/imgs/shop/home/quick_buy.png`,
        url: '/member/quickBuy'
      },
      invite_register: {
        text: `邀请${
          Stores.AppMod.userInfo && Stores.AppMod.userInfo.memberRetail
            ? openCardText
            : oldOpenCardText
        }`,
        icon: `${CDN_BASE}/assets/imgs/shop/home/invite_card.png`,
        url: '/personal/invite'
      },
      order_agency: {
        text: '代零售复销',
        icon: `${CDN_BASE}/assets/imgs/shop/home/agent_order.svg`,
        url: ''
      },
      register_agency: {
        text: '代客注册',
        icon: `${CDN_BASE}/assets/imgs/shop/home/agent_register.svg`
        // url: '/member/agentRegister',
      },
      upgrade_agency: {
        text: '老客升级',
        icon: `${CDN_BASE}/assets/imgs/shop/home/agent_up.svg`,
        url: '/store/businessManage/agentUpgrade'
      },
      oder_demand: {
        text: '订单查询',
        icon: `${CDN_BASE}/assets/imgs/shop/home/query_order.svg`
        // url: '/member/order/search',
      },
      wallet_store: {
        text: `${Stores.AppMod.isHiddenShop ? '店铺' : ''}钱包`,
        icon: `${CDN_BASE}/assets/imgs/shop/home/store_wallet.svg`,
        url: '/store/wallet'
      }
    };

    return list.map((item) => {
      return Object.assign(item, AppData[item.code]);
    });
  }

  static isEmpty(value) {
    value = value ? `${value}`.trim() : value;
    return value === '' || value == null || value == undefined;
  }

  static parInt(value) {
    return parseInt(value);
  }

  static getJson(url) {
    return new Promise((resolve, reject) => {
      let requestURL = url || 'https://image-uat.yofoto.cn/image/paohuidomain.json';
      // 创建一个HTTP请求对象
      let request = new XMLHttpRequest();
      // 使用open（）打开一个新请求
      request.open('GET', requestURL);
      // 设置XHR访问JSON格式数据，然后发送请求
      // request.responseType = 'json';
      // 设置XHR访问text格式数据
      request.responseType = 'text';
      request.send();
      // 处理来自服务器的数据
      request.onload = function () {
        let superHeroesText = request.response;
        let superHeroes = JSON.parse(superHeroesText);
        resolve(superHeroes);
      };
    });
  }

  // 判断链接的文件类型
  static getFileType(url) {
    let arr = url.split('.');
    if (['bmp', 'tiff', 'jpg', 'jpeg', 'png', 'svg', 'gif'].includes(arr[arr.length - 1])) {
      return 'image';
    }
    if (['flv', 'mov', 'wmv', 'mp4', 'avi'].includes(arr[arr.length - 1])) {
      return 'video';
    }
  }

  static getKeysLocalCache(keys = []) {
    let obj = {};
    Array.isArray(keys) &&
      keys.forEach((v) => {
        obj[v] = localStorage.getItem(v);
      });
    return obj;
  }

  static setKeysLocalCache(obj = {}) {
    for (const [key, value] of Object.entries(obj)) {
      console.log(`${key}: ${value}`);
      localStorage.setItem(key, value);
    }
  }

  static groupBypinyin(nameArr, key = 'title') {
    // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Operators/Comma_Operator
    if (!Array.isArray(nameArr)) return [];
    return nameArr
      .map((v) => ({
        ...v,
        title: Pinyin.getSpell(v.name, function (charactor, spell) {
          console.log(charactor, spell);
          return spell[0];
        })
          .charAt(0)
          .toLocaleUpperCase()
      }))
      .reduce((t, v) => (!t[v[key]] && (t[v[key]] = []), t[v[key]].push(v), t), {});
  }

  // 判断是否JSON格式
  static isValidJSON(data) {
    try {
      JSON.parse(data);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   *
   * 寻找数组中某个对象的某个字段的最小值
   * @static
   * @param {*} array
   * @param {*} key
   * @return {*}
   * @memberof util
   */
  static findMin(array, key) {
    return Math.min(
      ...array.map(function (o) {
        return o[key];
      })
    );
  }

  /**
   *
   * 寻找数组中某个对象的某个字段的最大值
   * @static
   * @param {*} array
   * @param {*} key
   * @return {*}
   * @memberof util
   */
  static finMax(array) {
    return Math.max(
      ...array.map(function (o) {
        return o[key];
      })
    );
  }

  // 判断给定的字符串是否是 JSON 字符串
  static isValidJSON(data) {
    try {
      JSON.parse(data);
      return true;
    } catch (e) {
      return false;
    }
  }

  static sortParams(params) {
    let keys = Object.keys(params).sort();
    const newParams = {};
    keys.forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        if (typeof params[key] === 'object' && params[key] && params[key].length === undefined) {
          newParams[key] = this.sortParams(params[key]);
        } else if (params[key] !== '') {
          newParams[key] = typeof params[key] === 'object' ? params[key] : `${params[key]}`;
        }
      }
    });
    return newParams;
  }

  // 完善资料提示
  static improveInfoModal({ content, userType, cardCode, accumulate }, callback) {
    Modal.alert('温馨提示', content || '暂未完善资料，为避免下单失败，请提前完善资料喔~', [
      {
        text: '取消',
        onPress: () => {
          callback && callback();
        }
      },
      {
        text: '完善资料',
        onPress: () => {
          window.app.router.replace({
            pathname: '/personal/msgAdd',
            state: {
              data: {
                accumulate: accumulate || 1,
                localCardCode: cardCode
              }
            }
          });
        }
      }
    ]);
  }

  // 证件类型
  static getCertTypeList() {
    const { showIdentityType4 } = Stores.AppMod;
    if (showIdentityType4) {
      return [
        { label: '身份证', value: 1 },
        { label: '护照', value: 2 },
        { label: '港澳台证', value: 3 },
        { label: '其它证件', value: 4 }
      ];
    }
    return [{ label: '身份证', value: 1 }];
  }

  /**
   * 浏览器型号
   */
  static getVersion() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'ios';
    }
    if (/(Android)/i.test(navigator.userAgent)) {
      return 'android';
    }
    if (navigator.userAgent.indexOf('WebKit') > -1) {
      return 'google';
    }
    return 'pc';
  }

  /**
   * 处理商学院登录后的跳转，如果体系配置了跳转新的商学院就跳转到新的商学院
   *
   * @memberof WechatBackLoginAuthView
   */
  static handleSXYLearning() {
    const registerRoute = this.getLocalCache(Config.localStorageKeys.registerRoute) || '';
    const appStore = Stores.AppMod;
    const { token, userInfo } = appStore;

    if (token) {
      // 新版商学院
      if (isHasRouteAuth(routeAuthCodeMap.EXPAND_TRAIN_NEW)) {
        let url = `http://sxyh5.${Config.HOST.toLowerCase()}.yofoys.cn`;
        if (['PROD', 'GREEN', 'BLUE'].includes(Config.HOST)) {
          url = 'https://study.huanongying.cn';
        }
        window.location.href = `${url}/#/home?n=${token}&d=${userInfo.id}`;
      }

      // 老版商学院
      if (isHasRouteAuth(routeAuthCodeMap.EXPAND_TRAIN)) {
        appStore.queryProjectDetail().then((data) => {
          const { moduleList } = data;
          const url = learningMenuMap[moduleList[0].type];
          if (url) {
            window.location.replace(`/#${url}`);
          }
        });
      }
    } else {
      window.location.replace(`/#${registerRoute}`);
    }
  }

  /**
   * 页面跳转逻辑
   */
  static gotoPage() {
    sessionStorage.setItem('noNeedAutoLogined', '1');
    const loginGoback = this.getLocalCache(Config.localStorageKeys.loginGoback) || '';
    // 是否返回上一个页面的标识
    const registerRoute = this.getLocalCache(Config.localStorageKeys.registerRoute) || '';
    if (loginGoback) {
      this.setLocalCache(Config.localStorageKeys.registerRoute, '');
      this.setLocalCache(Config.localStorageKeys.loginGoback, '');
      if (registerRoute) {
        sessionStorage.removeItem('routerCount');
        const isSXY = registerRoute.indexOf('learn/finding') > -1;
        if (isSXY && !!Stores.AppMod.workWechatAgentId) {
          this.handleSXYLearning();
        } else {
          window.location.replace(`/#${registerRoute}`);
        }
      } else {
        const referrer = document.referrer || '';
        const isGoogleReferrer = /(^|\/\/)([^/]*\.)?google\./i.test(referrer);
        if (isGoogleReferrer) {
          // 当前是一个异常case：设置了back的标志位，但是没有指定跳转路径（很多活动页都如此）
          // 对于Google登录这种场景，如果直接goBack会后退到google页面，也不能明确指定后退几步，
          // 因为强行执行goBack(-x)会后退到不可预知的页面（比如google的登录态和非登录态步骤不一样），
          // 所以，这里直接返回到首页
          window.location.replace(
            `${window.location.origin}${window.location.pathname}#/shop/home`
          );
        } else {
          window.app.router.goBack();
        }
      }
    } else {
      window.location.replace(`${window.location.origin}${window.location.pathname}#/shop/home`);
    }
  }

  static judgeColor(value) {
    if (!value) return 'white';
    if (/^#([0-9a-fA-f]{3}|[0-9a-fA-f]{4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(value)) {
      if (value.length === 4 || value.length === 5) {
        let sColorNew = '#';
        for (let i = 1; i < value.length; i++) {
          sColorNew += value.slice(i, i + 1).concat(value.slice(i, i + 1));
        }
        value = sColorNew;
      }
      // 处理六位的颜色值
      let sColorChange = [];
      for (let i = 1; i < value.length; i += 2) {
        sColorChange.push(parseInt(`0x${value.slice(i, i + 2)}`));
      }
      if (sColorChange[3]) {
        sColorChange[3] /= 255;
      }
      value = `${sColorChange.length === 3 ? 'rgb' : 'rgba'}(${sColorChange.join(',')})`;
    }
    if (/^(rgb|RGB)/.test(value)) {
      let RgbValue = value.replace('rgb(', '').replace(')', '');
      let RgbValueArry = RgbValue.split(',');
      if (RgbValueArry[3] && RgbValueArry[3] < 0.5) {
        return 'light';
      }
      if (RgbValueArry[0] * 0.299 + RgbValueArry[1] * 0.587 + RgbValueArry[2] * 0.114 >= 127) {
        return 'light';
      }
      return 'dark';
    }
    return 'light';
  }

  static useStores(name) {
    const stores = React.useContext(MobXProviderContext) || {};
    return stores[name];
  }

  /**
   * @deprecated 将 vh 转换为 px
   * @param {*} vh
   * @returns px
   */
  static vhToPx(vh) {
    return Math.round(window.innerHeight / (100 / vh));
  }

  /**
   * @deprecated 将 px 转换为 rem
   * @param {*} vh
   * @returns px
   */
  static pxToRem(px) {
    return `${px / 100}rem`;
    const fontSize = document.documentElement.style.fontSize;
    let c = 100;
    try {
      c = fontSize.split('px')[0];
    } catch (error) {}
    return `${px / (c || 100)}rem`;
  }

  /**
   * @description 清除多余空格
   * @param {*} str
   * @returns
   */
  static clearSpaces = (str) => {
    return str.replace(/\s+/g, '');
  };

  static getProductImg(list) {
    let imgUrl = '';
    if (list && list.length > 0) {
      const { path1, path2 } = (list && list.find((item) => item.fileType == 1)) || {};
      imgUrl = path1 || path2;
    }
    return imgUrl;
  }
  static copyText = (v, callback) => {
    const s = copy(v);
    if (s) {
      return 1;
      callback(1);
      // Toast.info('复制成功');
    } else {
      return 0;
      callback(0);
      // Toast.info('复制失败');
    }
  };

  /**
   * @description 替换链接上的参数
   * @param url 链接
   * @param param 参数key
   * @param newValue key 对应的新值
   * @returns 返回新的链接 URL
   */
  static replaceQueryParam = (url, param, newValue) => {
    const [baseUrl, hash] = url.split('#');
    let newUrl = baseUrl;
    if (hash) {
      const [path, query] = hash.split('?');
      let params = new URLSearchParams(query);
      params.set(param, newValue);
      const newHash = path + '?' + params.toString();
      newUrl += '#' + newHash;
    }
    return newUrl;
  };
  static haveAnySameKey = (obj1, obj2) => {
    // 获取 obj1 的键数组
    const keys1 = Object.keys(obj1);
    // 使用 some 方法检查是否有相同的键
    return keys1.some((key) => obj2.hasOwnProperty(key));
  };

  /**
   * @description toast弹框点击可穿透 并有消失前一个toast 的效果
   */
  static toastCanClick = (title, donation, fun, passive = false) => {
    Toast.hide();
    Toast.info(title || '成功', donation || 2, fun || null, false || passive);
  };

  /**
   * @description 返回上一页判断
   */
  static goBack = () => {
    if (window.history.length <= 1) {
      window.app.router.push('/');
    } else {
      window.app.router.goBack();
    }
  };
  // 是否DWCS
  static isDWCS = () => {
    let systemCode = getQueryString('systemCode') || sessionStorage.getItem('systemCode');

    const location = window.location;
    const { host = '' } = location;
    if (
      (systemCode && systemCode == 'DWCS') ||
      ['h5.nbmqdz.com', 'h5.uat3.nbmqdz.com', 'h5.uat5.nbmqdz.com'].includes(host)
    ) {
      return true;
    } else {
      return false;
    }
  };

  // 是否WLM
  static isWLM = () => {
    let systemCode = getQueryString('systemCode') || sessionStorage.getItem('systemCode');

    const location = window.location;
    const { host = '' } = location;
    if ((systemCode && systemCode == 'WLM') || ['h5.nbxpdz.com'].includes(host)) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * @description 获取环境
   * @returns object params { env: 环境, isProd: 是否是生产环境 }
   */
  static getEnv = () => {
    try {
      const isProd = ['GREEN', 'PROD'].includes(Config.HOST);
      return { env: Config.HOST, isProd };
    } catch (error) {
      return { env: 'PROD', isProd: true };
    }
  };

  /**
   * @description 解析URL查询参数，返回对象
   * @param {string} url
   * @returns {object}
   */
  static getQueryParams = (url) => {
    if (!url || typeof url !== 'string') return {};
    const queryStr = url.split('?')[1];
    if (!queryStr) return {};
    return queryStr.split('&').reduce((acc, cur) => {
      const [key, value] = cur.split('=');
      if (key) acc[decodeURIComponent(key)] = decodeURIComponent(value || '');
      return acc;
    }, {});
  };
  static isGoWeiXinLogin = () => {
    let tmpDomainList = [
      'h5.fnble.com',
      'h5.nbmqdz.com',
      'h5.uat3.nbmqdz.com',
      'h5.uat5.nbmqdz.com',
      'localhost'
    ];

    if (tmpDomainList.includes(window.location.host)) {
      // 不需要静默登录的域名
      return true;
    }
    return false;
  };
  // 根据key获取语言
  static getLngKey = (key = 'translation') => {
    let currentLng = window.currentLng || 'cn';
    if (util.getQueryString('lng')) {
      currentLng = util.getQueryString('lng') || '';
    }
    let keyLng = `${key}`;
    if (currentLng) {
      keyLng = `${key}_${currentLng}`;
    }
    return keyLng;
  };
  // 获取对应语言缓存
  static getLngStorage = (key = 'translation') => {
    const keyLng = util.getLngKey(key);
    return localStorage.getItem(keyLng);
  };
  // 设置对应语言缓存
  static setLngStorage = (key, value) => {
    const keyLng = util.getLngKey(key);
    localStorage.setItem(keyLng, value);
  };

  // URL header头部参数缓存配置
  static PERSIST_HEADER_CONFIG = [
    // 语言: URL参数 lng -> Storage lng -> Header language
    // { key: 'lng', headerKey: 'language', storage: 'local', defaultValue: 'cn' },
    // 国家: URL参数 country -> Storage country -> Header country
    { key: 'country', storage: 'local', defaultValue: '' }
  ];

  /**
   * 自动处理URL参数持久化
   * 遍历配置，如果URL中有对应参数，则存入Storage
   */
  static syncUrlParamsToStorage = () => {
    util.PERSIST_HEADER_CONFIG.forEach((item) => {
      const val = util.getQueryString(item.key);
      if (val) {
        const storage = item.storage === 'session' ? sessionStorage : localStorage;
        storage.setItem(item.storageKey || item.key, val);
      }
    });
  };

  static getSendMsgParamsUat = () => {
    try {
      const isUat = ['UAT3', 'UAT5', 'UAT'].includes(Config.HOST);
      return isUat ? sendMsgParamsUat : sendMsgParams;
    } catch (error) {
      return sendMsgParams;
    }
  };

  /**
   * 判断是否钻卡以下
   * cardType: -1优惠顾客, 0普卡, 1银卡, 2金卡, 3钻卡, 4红钻, 5蓝钻, 6金钻
   * @returns {boolean} true=钻卡以下（优惠顾客/普卡/银卡/金卡），false=钻卡及以上
   */
  static isBelowDiamond = () => {
    const { userInfo } = Stores.AppMod || {};
    const { cardType } = userInfo || {};
    return !(cardType >= 3);
  };

  // 是否显示返回上一页图标
  // gcc渠道部分页面不显示返回上一页图标
  static showGccBackIcon() {
    const appId = this.getLocalCache('member_appId');
    if (appId == '10980413') {
      // gcc
      return false;
    }
    return true;
  }
}

export default util;



// WEBPACK FOOTER //
// ./src/utils/index.js